<div class="page-layout simple fullwidth">
    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <h2>{{ "BILLS.MYBILLS" | translate | uppercase }}</h2>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="center p-24 pb-56">
        <div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="start center">
                <div class="h1 pr-16">Facturas</div>
                <button
                    mat-icon-button
                    color="accent"
                    (click)="mostrarFiltros = !mostrarFiltros"
                >
                    <mat-icon color="secondary">filter_list</mat-icon>
                </button>
            </div>

            <app-searchbox
                *ngIf="clientes && estados"
                class="mb-16"
                [hidden]="!mostrarFiltros"
                [estados]="estados"
                [clientes]="clientes"
                (filtrarFactura)="filtrar($event)"
            >
            </app-searchbox>

            <app-tabla-facturas
                *ngIf="facturas"
                [totalRegistros]="total"
                [facturas]="facturas"
                [configuracion]="configuracionFacturas"
                (buscarMas)="buscarFacturas($event)"
            ></app-tabla-facturas>
        </div>
    </div>

    <!-- / CONTENT -->
</div>
